const BookOpen = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 15H3.9C3.05992 15 2.63988 15 2.31901 14.8365C2.03677 14.6927 1.8073 14.4632 1.66349 14.181C1.5 13.8601 1.5 13.4401 1.5 12.6V5.4C1.5 4.55992 1.5 4.13988 1.66349 3.81901C1.8073 3.53677 2.03677 3.3073 2.31901 3.16349C2.63988 3 3.05992 3 3.9 3H4.2C5.88016 3 6.72024 3 7.36197 3.32698C7.92646 3.6146 8.3854 4.07354 8.67302 4.63803C9 5.27976 9 6.11984 9 7.8M9 15V7.8M9 15H14.1C14.9401 15 15.3601 15 15.681 14.8365C15.9632 14.6927 16.1927 14.4632 16.3365 14.181C16.5 13.8601 16.5 13.4401 16.5 12.6V5.4C16.5 4.55992 16.5 4.13988 16.3365 3.81901C16.1927 3.53677 15.9632 3.3073 15.681 3.16349C15.3601 3 14.9401 3 14.1 3H13.8C12.1198 3 11.2798 3 10.638 3.32698C10.0735 3.6146 9.6146 4.07354 9.32698 4.63803C9 5.27976 9 6.11984 9 7.8"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BookOpen;
